import React from 'react';
import PageTitle from '../shared/PageTitle/PageTitle';

const Users = () => {
    return (
        <table className='table-fixed'>
        <PageTitle title="Make Admin" />

    <div className="container mx-auto px-4 sm:px-8 max-w-full">
    <div className="py-8">
        <div className="-mx-4 sm:-mx-8 px-4 sm:px-8 py-4 overflow-x-auto">
            <div className="inline-block min-w-full shadow rounded-lg overflow-hidden">
                <table className="min-w-full leading-normal">
                    <thead>
                        <tr>
                            <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                                All Users
                            </th>
                            <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                                Email
                            </th>
                            <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                                Role
                            </th>
                           
                            <th scope="col" className="px-5 py-3 bg-white  border-b border-gray-200 text-gray-800  text-left text-sm uppercase font-normal">
                                Delete
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                            Jean marc
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        Jeanmarc@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-green-300">Make Admin</button>
                            </td>

                            

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-red-300">Remove Admin</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                            Jean marc
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        Jeanmarc@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-green-300">Make Admin</button>
                            </td>

                            

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-red-300">Remove Admin</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                            Jean marc
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        Jeanmarc@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-green-300">Make Admin</button>
                            </td>

                            

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-red-300">Remove Admin</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                            Jean marc
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        Jeanmarc@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-green-300">Make Admin</button>
                            </td>

                            

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-red-300">Remove Admin</button>
                            </td>
                        </tr>
                        <tr>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="ml-3">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                            Jean marc
                                        </p>
                                    </div>
                                </div>
                            </td>
                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                                <div className="flex items-center">
                                   
                                    <div className="">
                                        <p className="text-gray-900 whitespace-no-wrap">
                                        Jeanmarc@gmail.com
                                        </p>
                                    </div>
                                </div>
                            </td>

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-green-300">Make Admin</button>
                            </td>

                            

                            <td className="px-5 py-5 border-b border-gray-200 bg-white text-sm">
                            <button className="btn btn-xs bg-red-300">Remove Admin</button>
                            </td>
                        </tr>
                        
                        
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>
</table>
    );
};

export default Users;